import { render } from "./portfolio-layout-container.vue?vue&type=template&id=8f993b46&scoped=true&ts=true"
import script from "./portfolio-layout-container.vue?vue&type=script&lang=ts"
export * from "./portfolio-layout-container.vue?vue&type=script&lang=ts"

import "./portfolio-layout-container.vue?vue&type=style&index=0&id=8f993b46&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f993b46"]])

export default __exports__